// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedIncidentItem_container__3pI8j","link":"RelatedIncidentItem_link__FRYSE","gray":"RelatedIncidentItem_gray__2sE6d"};